@let isLoading = !!(isLoading$ | async);
@let isInsideSummary = $isInsideSummary();

<div class="my-4.5 flex flex-wrap gap-4 justify-between">
  @for (
    requestDevice of requestDevices;
    track requestDevice.id;
    let index = $index
  ) {
    <div
      class="x-card x-card_size_m x-white max-w-[630px]"
      [ngClass]="{
        'p-[20px] min-w-[480px] w-full flex-1': isInsideSummary,
        'w-full': !isInsideSummary,
      }"
    >
      @if ($activeRequestDeviceEdition() === requestDevice.id) {
        <x-request-form-devices-request-device-update
          [device]="requestDevice"
          (formClosed)="onUpdateFormClosed($event)"
        ></x-request-form-devices-request-device-update>
      } @else {
        <x-request-form-devices-device
          [device]="requestDevice"
          [deviceInstallQualityInput]="
            $devicesInstallQualityInput()?.[requestDevice!.deviceHash] || null
          "
          [orderNumber]="index + 1"
          [isInsideSummary]="isInsideSummary"
          (deviceDataUpdated)="onRequestDeviceUpdated()"
          (editRequestDeviceButtonClicked)="showRequestDeviceEditForm($event)"
          (requestDeviceRemoved)="onRequestDeviceRemoved()"
        ></x-request-form-devices-device>
      }
    </div>
  } @empty {
    <div
      class="x-card x-card_size_m x-white mb-2 mt-3 w-full max-w-[600px] mx-auto"
      [tuiSkeleton]="isLoading && isInitialLoad"
      [ngClass]="{ 'max-w-full mt-8': isInsideSummary }"
    >
      <div class="grid grid-cols-1 gap-2 x-text-03">
        <x-empty-block
          [title]="'request_form.devices.no_devices' | translate"
        />
      </div>
    </div>
  }

  <x-request-form-devices-request-device-adding
    (formClosed)="onAddingFormClosed($event)"
    class="block mt-5"
    [tuiSkeleton]="isLoading && isInitialLoad"
    [ngClass]="{ 'rounded-(--tui-radius-l)': isLoading && isInitialLoad }"
    [outsideToggleAddDeviceForm]="$toggleAddDeviceForm()"
    [isInsideSummary]="$isInsideSummary()"
  ></x-request-form-devices-request-device-adding>
</div>
